/* The theme's copy of the MDN.klaviyo client (gold: the tail of shell.js) —
   its own asset so the password layout, which does not carry the shell,
   can load it too. Keep the two in step. */
/* ---------------------------------------------------------------------
   KLAVIYO (Seamas, 2026-08-30: "connect these email intakes to klaviyo").
   The store's Klaviyo account is UwZ5JH. Its client API (public key,
   made for browsers) does two things for us: CREATE OR UPDATE A PROFILE —
   the email plus the properties we attach (which product they asked for,
   where they signed up) — which needs no list at all; and SUBSCRIBE that
   profile to a list with an email-marketing consent record, which needs
   the list's id (Klaviyo -> Lists & Segments -> the list -> Settings).
   The id arrives through window.MDN_KLAVIYO (the theme reads its MONDAIN
   setting in the layout; the static build fills LIST below). Every intake
   calls collect(): the profile always lands in Klaviyo; the list
   subscription is added the moment an id is set.
   --------------------------------------------------------------------- */
(function () {
  'use strict';
  var COMPANY = 'UwZ5JH', LIST = '', REV = '2026-07-15';
  function cfg() {
    var c = window.MDN_KLAVIYO || {};
    return { company: c.company || COMPANY, list: String(c.list || LIST).trim() };
  }
  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(cfg().company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REV },
      body: JSON.stringify(body),
      keepalive: true
    }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + path + ' ' + r.status); return r; });
  }
  function stamp(props, source) {
    var p = {};
    for (var k in props) if (Object.prototype.hasOwnProperty.call(props, k)) p[k] = props[k];
    p.mondain_source = source || 'mondain.page';
    p.mondain_signed_up_at = new Date().toISOString();
    p.mondain_page = location.pathname;
    return p;
  }
  /* the profile: email + properties, no list needed */
  function identify(email, props, source) {
    return post('profiles', { data: { type: 'profile', attributes: { email: email, properties: stamp(props, source) } } });
  }
  /* the list: consent recorded, membership added — needs the list id */
  function subscribe(email, props, source) {
    var c = cfg();
    if (!c.list) return Promise.reject(new Error('klaviyo: no list configured'));
    return post('subscriptions', { data: { type: 'subscription', attributes: {
      custom_source: source || 'mondain.page',
      profile: { data: { type: 'profile', attributes: {
        email: email,
        properties: stamp(props, source),
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      } } }
    }, relationships: { list: { data: { type: 'list', id: c.list } } } } });
  }
  /* what an intake calls: the profile always; the list when there is one.
     Resolves { profile: true, subscribed: bool }; rejects only if even the
     profile could not be sent */
  function collect(email, props, source) {
    return identify(email, props, source).then(function () {
      if (!cfg().list) return { profile: true, subscribed: false };
      return subscribe(email, props, source).then(
        function () { return { profile: true, subscribed: true }; },
        function () { return { profile: true, subscribed: false }; });
    });
  }
  /* AN EVENT, not just a profile (Seamas, 2026-10-17: "we need product specific
     flows in klaviyo so we can retarget"). A profile property cannot trigger a
     flow; a metric can. Each intake fires one, carrying the product, so a flow
     triggers on the metric and filters to a single handle. Klaviyo's own
     "Subscribed to Back in Stock" is NOT used: it keys off catalog variants and
     this account's catalog is empty (the Shopify catalog sync is off), so the
     native back-in-stock flow has nothing to hang on. Turn that sync on and this
     can move over. */
  function track(metric, email, props, source) {
    return post('events', { data: { type: 'event', attributes: {
      properties: stamp(props, source),
      metric: { data: { type: 'metric', attributes: { name: metric } } },
      profile: { data: { type: 'profile', attributes: { email: email } } }
    } } });
  }
  /* what a NOTIFY ME intake calls: the profile + list as before, plus the event.
     The event is best-effort — a failed metric must never lose the sign-up. */
  function notify(email, props, source) {
    return collect(email, props, source).then(function (r) {
      return track('Notify Me Request', email, props, source).then(
        function () { r.tracked = true; return r; },
        function () { r.tracked = false; return r; });
    });
  }

  window.MDN = window.MDN || {};
  window.MDN.klaviyo = { identify: identify, subscribe: subscribe, collect: collect, track: track, notify: notify, config: cfg };
})();
